var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.25C2.41421 1.25 2.75 1.58579 2.75 2V20C2.75 20.6904 3.30964 21.25 4 21.25H14.6853C15.4733 21.6753 16.3751 21.9167 17.3333 21.9167C18.0457 21.9167 18.7284 21.7826 19.3564 21.5384L20.409 22.591C20.4657 22.6476 20.5246 22.7007 20.5855 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V2C1.25 1.58579 1.58579 1.25 2 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.003V11C19 10.4477 18.5523 10 18 10H14C13.4477 10 13 10.4477 13 11V12.8123C14.0237 11.5539 15.5847 10.75 17.3333 10.75C17.9138 10.75 18.4737 10.8386 19 11.003Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 5.44772 5.44772 5 6 5H10C10.5523 5 11 5.44772 11 6V18C11 18.5523 10.5523 19 10 19H6C5.44772 19 5 18.5523 5 18V6Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 13.75C15.9066 13.75 14.75 14.9066 14.75 16.3333C14.75 17.7601 15.9066 18.9167 17.3333 18.9167C18.7601 18.9167 19.9167 17.7601 19.9167 16.3333C19.9167 14.9066 18.7601 13.75 17.3333 13.75ZM13.25 16.3333C13.25 14.0782 15.0782 12.25 17.3333 12.25C19.5885 12.25 21.4167 14.0782 21.4167 16.3333C21.4167 17.1899 21.1529 17.9849 20.7022 18.6415L22.5303 20.4697C22.8232 20.7626 22.8232 21.2374 22.5303 21.5303C22.2374 21.8232 21.7626 21.8232 21.4697 21.5303L19.6415 19.7022C18.9849 20.1529 18.1899 20.4167 17.3333 20.4167C15.0782 20.4167 13.25 18.5885 13.25 16.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCheck);
export default __webpack_public_path__ + "static/media/bar-check.044e76f5d0cd23abbd4819b320d25c7a.svg";
export { ForwardRef as ReactComponent };